var map = {
	"./AIT Worldwide.jpg": 2293,
	"./Aerosafe.png": 6124,
	"./Airspace.png": 6558,
	"./American Airlines.png": 5289,
	"./Associated Couriers.png": 3092,
	"./Biocair.png": 9249,
	"./Biotouch.png": 3275,
	"./Boyle Transportation.png": 2199,
	"./Cryoport.png": 5717,
	"./DB Schenker.png": 9247,
	"./DHL.png": 4002,
	"./DSV.png": 6385,
	"./Delta Airlines.png": 6827,
	"./Despir.png": 6629,
	"./Dropoff.png": 4228,
	"./FedEx.png": 9864,
	"./Kuehne + Nagel.png": 7258,
	"./MDS.jpg": 4908,
	"./MNX.png": 7245,
	"./Marken.png": 1950,
	"./Medspeed.png": 1019,
	"./Mercury.png": 8237,
	"./QuickSTAT.png": 7693,
	"./Skelton Truck Lines.png": 9930,
	"./Southwest Airlines.png": 5451,
	"./UPS.png": 8156,
	"./USPS.png": 5711,
	"./United Airlines.png": 8032,
	"./World Courier.png": 3023,
	"./time-matters.png": 8718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8098;